import { Pipe, PipeTransform } from '@angular/core';
import {Employee} from '../lead-form-app/model/employee.model';

@Pipe({
  name: 'coopEmployeeName'
})
export class CoopemployeeNamePipe implements PipeTransform {

  transform(employee: Employee): unknown {
    return `${employee?._embedded?.salutation?.name ? this.getDativ(employee._embedded.salutation.name) : ''}
            ${employee?._embedded?.title?.name ? employee._embedded.title.name : ''}
            ${employee?.firstName ? employee.firstName : ''} ${employee?.lastName ? employee.lastName : ''}`;
  }

  getDativ(salutation: string) {
    return salutation === 'Herr' ? 'Herrn' : salutation;
  }
}
